import { IWorkShiftChart } from 'types';

export interface IReturnValue {
  chartLoading: boolean;
  workShifts: Array<IWorkShiftChart> | undefined;
  getWorkShifts: CallableFunction;
}
export enum EType {
  SHIFTS,
  SUMMARY,
}
